"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Represents the type of the appender.
 * For example, appender can append data to console, to remote URL, to local storage, to some socket, webhook or simply ignore it.
 * Custom appenders can be used to define the inlined behavior.
 */
var AppenderType;
(function (AppenderType) {
    /**
     * Representing {@link EmptyAppender}.
     */
    AppenderType[AppenderType["Empty"] = 0] = "Empty";
    /**
     * Representing {@link ConsoleAppender}.
     * Writes structured {@link ILogMessage} to the console.
     */
    AppenderType[AppenderType["Console"] = 1] = "Console";
    /**
     * Representing {@link ConsoleNativeAppender}.
     * Writes **message text** to the console - same as using `console.*` JS calls.
     */
    AppenderType[AppenderType["ConsoleNative"] = 2] = "ConsoleNative";
    /**
     * Representing {@link RemoteAppender}.
     * Writes structured {@link ILogMessage} to the remote storage.
     */
    AppenderType[AppenderType["Remote"] = 3] = "Remote";
    /**
     * Representing {@link CustomAppender}.
     * Custom appender implementation, requires more details at {@link Appender} implementation.
     */
    AppenderType[AppenderType["Custom"] = 4] = "Custom";
    /**
     * Representing {@link BIRemoteAppender}.
     * Writes BI Log to Jarvis.
     */
    AppenderType[AppenderType["BIRemote"] = 5] = "BIRemote";
})(AppenderType = exports.AppenderType || (exports.AppenderType = {}));
/**
 * Represents the log level.
 * A log request of level p in a logger with level q is enabled if p >= q.
 * It assumes that levels are ordered.
 * For the standard levels, we have `ALL < TRACE < DEBUG < INFO < WARN < ERROR < FATAL < OFF`.
 * @see https://www.tutorialspoint.com/log4j/log4j_logging_levels.htm
 */
var LogLevel;
(function (LogLevel) {
    /**
     * All levels including custom levels.
     */
    LogLevel[LogLevel["All"] = 0] = "All";
    /**
     * Designates finer-grained informational events than the DEBUG.
     */
    LogLevel[LogLevel["Trace"] = 1] = "Trace";
    /**
     * Designates fine-grained informational events that are most useful to debug an application.
     */
    LogLevel[LogLevel["Debug"] = 2] = "Debug";
    /**
     * Designates informational messages that highlight the progress of the application at coarse-grained level.
     */
    LogLevel[LogLevel["Info"] = 3] = "Info";
    /**
     * Designates potentially harmful situations.
     */
    LogLevel[LogLevel["Warn"] = 4] = "Warn";
    /**
     * Designates error events that might still allow the application to continue running.
     */
    LogLevel[LogLevel["Error"] = 5] = "Error";
    /**
     * Designates very severe error events that will presumably lead the application to abort.
     */
    LogLevel[LogLevel["Fatal"] = 6] = "Fatal";
    /**
     * The highest possible rank and is intended to turn off logging.
     */
    LogLevel[LogLevel["Off"] = 7] = "Off";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
var EventType;
(function (EventType) {
    EventType["Log"] = "Log";
    EventType["BusinessReport"] = "BI";
})(EventType = exports.EventType || (exports.EventType = {}));
/**
 * The mode of the {@link IConfig} config.
 */
var ConfigMode;
(function (ConfigMode) {
    /**
     * used to debug the library, write debugging info to the console.
     */
    ConfigMode[ConfigMode["Debug"] = 0] = "Debug";
    /**
     * (default) for production use.
     */
    ConfigMode[ConfigMode["Release"] = 1] = "Release";
})(ConfigMode = exports.ConfigMode || (exports.ConfigMode = {}));
//# sourceMappingURL=enums.js.map